// extracted by mini-css-extract-plugin
export var content = "Footer-module--content--03575";
export var copyright = "Footer-module--copyright--a775b";
export var links = "Footer-module--links--2e581";
export var logo = "Footer-module--logo--2eef9";
export var social = "Footer-module--social--6e211";
export var wrapper = "Footer-module--wrapper--46564";